import DataTable from "datatables.net";
import "datatables.net-dt";
import Buttons from "datatables.net-buttons";
import "datatables.net-buttons-dt";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

import * as datatablesLanguageEnGb from "datatables.net-plugins/i18n/en-GB.json";
import * as datatablesLanguageEsES from "datatables.net-plugins/i18n/es-ES.json";
import * as datatablesLanguageFrFr from "datatables.net-plugins/i18n/fr-FR.json";
import * as datatablesLanguageItIt from "datatables.net-plugins/i18n/it-IT.json";

import * as JSZip from 'jszip';
(window as any).JSZip = JSZip;

type DataTablesOrder = [number, 'asc' | 'desc'];

interface DataTablesOptions {
  dom?: string;
  buttons?: any[];
  columnDefs?: any[];
  ordering?: boolean;
  order?: DataTablesOrder[];
  language?: any;
  [key: string]: any;
}

export default ({
  htmlId = "#table_id",
  languageCode = "fr_FR",
  datablesOptions = {} as DataTablesOptions,
  enableExport = false,
}: {
  htmlId?: string;
  languageCode?: string;
  datablesOptions?: DataTablesOptions;
  enableExport?: boolean;
}) => {
  let datablesLanguage: any;
  switch (languageCode) {
    case "fr":
    case "fr_FR":
    case "fr_CA":
      datablesLanguage = datatablesLanguageFrFr;
      break;
    case "en":
    case "en_US":
      datablesLanguage = datatablesLanguageEnGb;
      break;
    case "es":
    case "es_ES":
      datablesLanguage = datatablesLanguageEsES;
      break;
    case "it":
    case "it_IT":
      datablesLanguage = datatablesLanguageItIt;
      break;
    default:
      datablesLanguage = datatablesLanguageFrFr;
      break;
  }

  // Configuration par défaut avec boutons d'export
  const defaultOptions: DataTablesOptions = {
    dom: enableExport ?
      '<"row mb-3"<"col-md-8 col-sm-12 mb-2 mb-md-0"f><"col-md-4 col-sm-12 text-md-end text-center"B>>rtip' :
      'frtip',
    buttons: enableExport ? [
      {
        extend: 'csvHtml5',
        text: 'Export CSV',
        className: 'floatleft'
      }
    ] : [],
    language: datablesLanguage,
  };

  // Fusion des options
  const options: DataTablesOptions = {
    ...defaultOptions,
    ...datablesOptions,
    // Fusionner les boutons si ils existent déjà
    buttons: [
      ...(defaultOptions.buttons || []),
      ...(datablesOptions.buttons || [])
    ]
  };

  // ATTENTION : avec DataTables 2.x, on utilise "new DataTable" (et plus jQuery)
  return new DataTable(htmlId, options);
};
